module.exports = __webpack_public_path__ + "static/media/user-add.56c000f3.svg";